export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEmail(v: string): string | undefined {
  const t = v.trim();
  if (!t) return 'Email is required.';
  if (!EMAIL_RE.test(t)) return 'Enter a valid email address.';
  return undefined;
}

export function validatePassword(v: string, opts?: { min?: number }): string | undefined {
  const min = opts?.min ?? 1;
  if (!v) return 'Password is required.';
  if (v.length < min) return `Password must be at least ${min} characters.`;
  return undefined;
}
